import { Route, Routes } from "react-router-dom";
import "./App.css";
import Landing from "./Components/LandingPage/Landing";
import Demo from "./Components/Demo/Demo";
import BuildChatbotStep from "./Components/BuildChatBot/BuildChatbotStep";
import SignUp from "./Components/SignUp/SignUp";
import SignIn from "./Components/SignIn/SignIn";
import AdminDashboard from "./Components/Admin/AdminDashboard";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Profile from "./Profile/Profile";
import Pricing from "./Components/Pricing/Pricing";
import AiAgents from "./Components/AiAgents/AiAgents";
import Dashboard from "./Components/Dashboard/Dashboard";
import BotDetails from "./Components/Dashboard/BotDetails";
import IntegrationWhatsApp from "./Components/Integration/integrationWhatsApp";
import IntegrationTelegram from "./Components/Integration/integrationTelegram";
import ProtectedRoutes from "./ProtectedRoutes";
import Docs from "./Components/Docs/Docs";

function App() {
  return (
    <>
      <Routes>
        <Route exact path="/" element={<Landing />} />
        <Route exact path="/bookdemo" element={<Demo />} />
        <Route exact path="/SignUp" element={<SignUp />} />
        <Route exact path="/SignIn" element={<SignIn />} />
        <Route exact path="/profile" element={<Profile />} />
        <Route exact path="/admin-dashboard" element={<AdminDashboard />} />
        <Route exact path="/pricing" element={<Pricing />} />
        <Route exact path="/aiAgents" element={<AiAgents />} />

        <Route element={<ProtectedRoutes />}>
          <Route exact path="/dashboard" element={<Dashboard />} />
          <Route exact path="/BuildChatBot" element={<BuildChatbotStep />} />
          <Route exact path="/bot/:botId" element={<BotDetails />} />
        </Route>


        <Route path="/bot/:botId/bookdemo" element={<Demo />} />
        <Route path="/integrations/whatsapp" element={<IntegrationWhatsApp />} />
        <Route path="/integrations/telegram" element={<IntegrationTelegram />} />
        <Route path="/docs" element={<Docs />} />
      </Routes>
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}

export default App;
